import React, { useState, useEffect } from "react";
import CarButton from "../components/CarButton";

const Section4 = ({ contenuti }) => {
    const [isMobile, setIsMobile] = useState(false);
    const contenutiArray = Array.isArray(contenuti) ? contenuti : Object.values(contenuti);

    
      useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth < 992);
        };
        handleResize(); 
        window.addEventListener("resize", handleResize);
    
        return () => {
          window.removeEventListener("resize", handleResize);
        };
      }, []);
    
  return (
    <>
      {contenutiArray.map((content, index) => {
        const {
          titolo1,
          titolo2,
          sottotitolo,
          descrizione,
          immaginiAggiuntive,
          callToAction,
          link,
        } = content;
        return (
          <div
          key={index}
          className="container-fluid d-flex flex-column justify-content-start position-relative "
          style={{
            padding: "64px 16px", 
            gap: "16px",
          }}
        >
        
          <div className="container">
            <div className="row w-100">
              {/* Left Text */}
              <div className="container col-12 col-md-6 d-flex flex-column align-items-start">
                {/* Titolo Chi Siamo */}
                <p className="mini-title">{sottotitolo}</p>
                <div className="title-section">
                <h2 className={`black-text ${isMobile ? 'd-block d-lg-none title-section-mobile' : 'd-none d-lg-block title-section'}`}>
                      {titolo1}
                    </h2>
                    <h2 className={`green-text ${isMobile ? 'd-block d-lg-none  title-section-mobile' : 'd-none d-lg-block title-section'}`} >{titolo2}</h2>
                </div>
              </div>
        
              {/* Right Text */}
              <div className="container col-12 col-md-6 d-flex flex-column align-items-start gap-3 mt-3 mt-md-0">
                <p
                  className="custom-text"
                  dangerouslySetInnerHTML={{ __html: descrizione }}
                ></p>
                <CarButton
                  text={callToAction} // Testo del bottone dinamico
                  to={link}
                  customClass="btn btn-three"
                />
              </div>
            </div>
          </div>
        
          {/* Verifica se ci sono immagini aggiuntive da mostrare */}
          {immaginiAggiuntive && immaginiAggiuntive.length > 0 ? (
            <div className="container py-3">
              <div className="col-12 d-flex flex-column flex-md-row justify-content-between">
                {immaginiAggiuntive.map((img, index) => (
                  <div
                    key={index}
                    className="col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0"
                  >
                    <img
                      src={img.immagine_path} // Percorso immagine dinamico
                      alt={`Image ${index + 1}`}
                      className="img-fluid"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : null} {/* Se immaginiAggiuntive è vuoto o null, il div non verrà renderizzato */}
        </div>
        
        
        );
      })}
    </>
  );
};

export default Section4;
